/**
 * GA4 events from the dashboard's pages (the public meeting page, the sign-in screens, follows): one small helper over
 * site/js/analytics.js, which cleans every event the same way as the site's (nothing a reader typed, no addresses or
 * emails) and adds the page's content group. Pages without the GA4 tag (the signed-in dashboard) send nothing:
 * window.gtag isn't there. docs/ANALYTICS.md lists every event.
 */
import { contentGroup, track as send, type Params } from "../../site/js/analytics.js";

export function track(name: string, params: Params = {}) {
  return send(name, params);
}

/** Who signed in, by how and from where: sign_up for an account made in the last ten minutes, else login. */
export function trackSignIn(method: "email_link" | "email_code" | "passkey", user?: { createdAt?: string | Date | null } | null, now = Date.now()) {
  const made = user?.createdAt ? new Date(user.createdAt).getTime() : NaN;
  const isNew = Number.isFinite(made) && now - made < 10 * 60_000;
  const q = typeof location !== "undefined" ? new URLSearchParams(location.search) : null;
  const next = q?.get("next");
  const source = next && next.startsWith("/") ? contentGroup(next) : typeof location !== "undefined" ? contentGroup(location.pathname) : "Other";
  return track(isNew ? "sign_up" : "login", { method, source });
}

/** The dashboard's follow kinds in the site's words: legislation is a matter. Topics are typed words: no id. */
export function trackFollow(on: boolean, type: string, id: string | null | undefined, signedIn: boolean) {
  const kind = type === "legislation" ? "matter" : type;
  return track(on ? "follow" : "unfollow", { type: kind, ...(kind !== "topic" && id ? { id: String(id) } : {}), signed_in: signedIn });
}
